import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, permission, superAdminOnly }) {
  const token = localStorage.getItem('adminToken');
  if (!token) return <Navigate to="/admin/login" replace />;

  const admin = JSON.parse(localStorage.getItem('adminInfo') || '{}');
  const isSuperAdmin = admin.role === 'admin';

  if (superAdminOnly && !isSuperAdmin)
    return <Navigate to="/admin/dashboard" replace />;

  if (permission && !isSuperAdmin && !(admin.permissions || []).includes(permission))
    return <Navigate to="/admin/dashboard" replace />;

  return children;
}
